module.exports = __webpack_public_path__ + "static/media/DOG_COMPATIBLE.2ec3a5ce.svg";